export default __webpack_public_path__ + "static/media/snd_00018.712f74e9.mp4";